/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/landing/index.tsx.
// Do not edit it manually.

import type __GeneratedRouteAppExport from "@/client/index";
import __routeDefinition from "../../../../client/pages/landing/index";
import { normalizeRouteDefinitions, registerRouteDefinition } from '@common/router/definitions';

type __GeneratedRouteApp = __GeneratedRouteAppExport extends abstract new (...args: any[]) => infer __GeneratedRouteAppInstance
  ? __GeneratedRouteAppInstance
  : __GeneratedRouteAppExport;

const __routeMetadata = [
  { filepath: "/repo/apps/website/client/pages/landing/index.tsx", sourceLocation: { line: 63, column: 16 }, id: "landing_index" }
];

export const __register = (app: __GeneratedRouteApp) => {
  const __definitions = normalizeRouteDefinitions(__routeDefinition as any, app as any);
  let __registeredRoute;
  for (let __index = 0; __index < __definitions.length; __index += 1) {
    __registeredRoute = registerRouteDefinition(app.Router as any, __definitions[__index] as any, __routeMetadata[__index]);
  }
  return __registeredRoute;
};
